export const ENTITLEMENT_GROUP_VALUE = 'EntitlementGroup_value';
export const LOGGED_IN_USER = 'loggedInUser';

export const MANAGE_TEST_CARE = 'manageTestCare';
export const MANAGE_TEST_PARAMETERS = 'manageTestParameters';
